<template>
  <text-input
    v-bind="{ required, label: showLabel, classes, placeholder, autocomplete }"
    :value="email"
    @input="updateEmail"
    :error="$root.errorBag.email">
    <template v-if="label">{{ label }}</template>
    <template #left v-if="emailIcon">
      <action-button disabled class="is-dark is-medium">
        <icon icon="envelope"/>
      </action-button>
    </template>
  </text-input>
</template>
<script>

export default {

  props: {
    store: {
      type: String,
      default: 'user'
    },

    label: String,
    placeholder: String,
    required: Boolean,
    emailIcon: Boolean,
    classes: [String, Object, Array],
    autocomplete: String,
  },

  methods: {
    updateEmail(value) {
      this.$store.commit(`${this.store}/updateEmail`, value)
    }
  },

  computed: {
    email() {
      return this.$store.getters[`${this.store}/user`].email
    },

    showLabel() {
      return (this.label?.length > 0)
    }
  }

}
</script>
